import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { CommonValidationRendererModule } from "@obg/ngx.ui.common";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";

import { SessionLimitItemCommonComponent } from "./session-limit-item.component";

const DIRECTIVES = [SessionLimitItemCommonComponent];

@NgModule({
	imports: [
		CoreModule,
		CoreUiModule,
		CoreContentModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		CommonValidationRendererModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class SessionLimitItemModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...DIRECTIVES);
	}
}
